import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div``

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const InformationTitle = styled.div`
  display: none;

  ${({ theme }) => media.sm`
    display: block;
    margin-bottom: ${theme.space.desktop.small};
  `}
`

export const InformationGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  ${media.sm`
    flex-direction: column;
  `}
`

export const InformationGridItem = styled.div`
  flex-shrink: 0;
  width: 50%;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.tiny};
  `}

  ${media.sm`
    width: 100%;
  `}
`
